import { FlagIcon } from 'react-flag-kit';
import { alpha, useTheme } from '@mui/material/styles';
import { MenuButton } from 'components/dropdown-menu';
import {
  AppLocale,
  getLocaleLanguage,
  initIntl,
  setCurrentLocale
} from 'modules/i18n';
import { mapFlagCode } from '../constants';

type Props = {
  label: string;
  locale: AppLocale;
};

export const MenuItem = ({ label, locale }: Props) => {
  const theme = useTheme();

  const appLocale = getLocaleLanguage();

  const getSxProps = () => ({
    '>p': locale === appLocale ? { fontWeight: 600 } : {},
    backgroundColor:
      locale === appLocale
        ? alpha(theme.palette.action.selected, 0.16)
        : 'transparent',
    '>img': { marginRight: 1 }
  });

  const handleSelectLanguage = async (locale: string) => {
    setCurrentLocale(locale);
    await initIntl(locale);
    window.location.reload();
  };

  return (
    <MenuButton
      label={label}
      color="text.primary"
      icon={
        <FlagIcon
          code={mapFlagCode[locale]}
          size={20}
          width={28}
          style={{ borderRadius: 3 }}
        />
      }
      onClick={() => handleSelectLanguage(locale)}
      sx={getSxProps}
    />
  );
};
